import React, {memo} from 'react';
import {View} from 'react-native';

import { StyleSheet } from 'react-native';

import {RNEText} from '../../components';

import {formatToMessageTime} from '../../utils/date.utils';
import { width, height, totalSize } from 'react-native-dimension';
import useStores from '../../stores/useStores';

interface ConsultationInformationMessageProps {
  timestamp: Date;
  fee?: string;
}

const ConsultationInformationMessage = (
  props: ConsultationInformationMessageProps,
) => {
  
  const {authStore} = useStores();

  return (
    <View style={styles.mainContainer}>
      <View style={styles.timestamp}>
        <RNEText
          label={formatToMessageTime(props.timestamp)}
          color="grey"
          variant="button"
          weight="600"
        />
      </View>
      <View
        style={
          props.fee ? styles.messageContainer : styles.lastMessageContainer
        }>
        <RNEText
          label={
            props.fee
              ? `Consultation request approved for ${props.fee} Php`
              : 'Payment for consultation confirmed.'
          }
          color="grey"
          variant="button"
          align="center"
        />
      </View>

      {
       authStore.auth?.user.userRole == 'patient' && !props.fee && (
          <View
            style={
              {
                ...styles.lastMessageContainer,
                marginTop: -height(1),
              }
            }>
              <RNEText
                label={
                  'Please wait for the doctor to contact you here to start the consultation.'
                }
                color="grey"
                variant="button"
                align="center"
              />
          </View>

         )
      }
      
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    marginTop: height(2),
  },
  timestamp: {
    alignItems: 'center',
    marginTop: height(2),
  },
  messageContainer: {
    marginTop: height(0.5),
  },
  lastMessageContainer: {
    marginTop: height(0.5),
    marginBottom: height(1),
  },
});

export default memo(ConsultationInformationMessage);
